import { useApiClient } from '../../hooks/useApiClient';
import { ApiResponse } from '../../types/ApiResponse.type';
import { FeatureFlag } from '../../types/FeatureFlag/FeatureFlag.type';
import { FeatureFlagAccess, FeatureFlagToggle } from '../../types/FeatureFlag/FeatureFlagUpdate.type';
import { GetFeatureFlagsQueryParams } from '../../types/QueryParams.type';
import { buildQueryString } from '../../utils/buildQueryString';

export const useFeatureFlagApi = () => {
  const apiClient = useApiClient();

  return {
    getFeatureFlags: (): Promise<string[]> => apiClient('/users/feature_flags'),

    getAllFeatureFlags: (params: GetFeatureFlagsQueryParams): Promise<ApiResponse<FeatureFlag[]>> => {
      const queryString = buildQueryString(params);

      return apiClient(`/feature_flags/${queryString}`);
    },

    toggleFeatureFlag: (flagId: number, updateData: FeatureFlagToggle): Promise<FeatureFlag> =>
      apiClient(`/feature_flags/${flagId}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      }),

    updateFeatureFlagAccess: (flagId: number, updateData: FeatureFlagAccess): Promise<FeatureFlag> =>
      apiClient(`/feature_flags/${flagId}/access`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      }),
  };
};
